import { render, staticRenderFns } from "./NanogenresData.vue?vue&type=template&id=3e7a5700&scoped=true&"
import script from "./NanogenresData.vue?vue&type=script&lang=js&"
export * from "./NanogenresData.vue?vue&type=script&lang=js&"
import style0 from "./NanogenresData.vue?vue&type=style&index=0&id=3e7a5700&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7a5700",
  null
  
)

export default component.exports